import { MutationHookOptions, useMutation } from '@apollo/client';

import { SaveSearchDocument, SaveSearchMutation, SaveSearchMutationVariables } from './savedSearches.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

const defaultOptions = { client: apolloClientContracts } as const;

export function useSaveSearchMutation(
  baseOptions?: MutationHookOptions<
  SaveSearchMutation,
  SaveSearchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation<SaveSearchMutation, SaveSearchMutationVariables>(
    SaveSearchDocument,
    options,
  );
}